








import { Vue, Component, Mixins } from "vue-property-decorator";
import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  totalPage: number = 0;
  ei: any = {};

  option: any = {
    tooltip: {
      formatter: (params: any) => {
        if (params.componentType === "markLine") {
          return `${params.name}：${params.value}`;
        }
        return `${params.value[3]}<br />球友数：${params.value[0]}<br />通讯录球友数：${
          params.value[1]
        }<br />打球次数：${params.value[2]}`;
      },
      axisPointer: {
        show: true,
        type: "cross"
      }
    },
    xAxis: {
      name: "球友数",
      scale: true,
      type: "value",
      splitLine: {
        lineStyle: {
          type: "dashed"
        }
      }
    },
    yAxis: {
      name: "通讯录球友数",
      type: "value",
      splitLine: {
        lineStyle: {
          type: "dashed"
        }
      },
      scale: true
    },
    series: [
      {
        type: "scatter",
        data: [],
        symbolSize: (data: any) => {
          //   console.log(data);
          return Math.sqrt(data[2]);
        },
        markLine: {
          lineStyle: {
            type: "solid"
          },
          data: [
            { type: "average", name: "通讯录平均值", valueIndex: 1 },
            { type: "average", name: "球友平均值", valueIndex: 0 }
          ]
        }
      }
    ]
  };

  async loadChartData(page: number) {
    const res = await this.$store.dispatch("datav/userData", {
      page,
      page_size: 5000
    });
    if (res && res.Data) {
      this.totalPage = res.Data.total_page;
      //   console.log(res.Data);
      for (const obj of res.Data.data) {
        this.option.series[0].data.push([
          Number(obj.ucount),
          Number(obj.ccount),
          Number(obj.pcount),
          obj.username
        ]);
      }
    }
  }

  async mounted() {
    this.loadChartData(1);
  }
}
